export default __webpack_public_path__ + "static/media/tasks.4484dfa4.svg";